import React from 'react'
import moon from './assets/images/basil_moon-solid.png'
import sun from './assets/images/ri_sun-fill.png'
import WbSunnySharpIcon from '@mui/icons-material/WbSunnySharp';
import NightlightRoundSharpIcon from '@mui/icons-material/NightlightRoundSharp';
const Toggle = ({ handleChange, isChecked }) => {
	return (
		// <div className='khojMode'>
		// 	<div className='toggle-container'>
		// 		<input type="checkbox"
		// 			id='check'
		// 			className='toggle'
		// 			onChange={handleChange}
		// 			checked={isChecked}
		// 		/>
		// 		<label htmlFor="check"
		// 		>Dark Mode</label>
		// 	</div>
		// </div>

		<div className='khojMode' onClick={handleChange}>
			<div className='icon-container'>
				{isChecked ? (
					<NightlightRoundSharpIcon className="mode-icon darkModeIcon" />
					// <img src={moon} alt="Dark Mode" className="mode-icon darkModeIcon" />
				) : (
					<WbSunnySharpIcon className="mode-icon lightModeIcon" />
					// <img src={sun} alt="Light Mode" className="mode-icon lightModeIcon" />
				)}
			</div>
		</div>
	)
}

export default Toggle